import './App.css';
import startup_kinito from './assets/sounds/Startupa2c.ogg'
import CWindow from './CWindow.js';
import Notes from './Notes.js';
import gottem from './topsecretlowest.mp4';

function Secret() {
  let nyanya;
  let started = false;
  let loaded = false;

  let nyaaoowo;
  let meowmeow;

  const startfr = () => {
    nyaaoowo.play();
    meowmeow.setAttribute('fading', 'true');
    if (!loaded) meowmeow.innerHTML = 'oops i slipped sorry';
    nyanya.setAttribute('initializing', 'fast');
    setTimeout(() => {
      nyanya.removeAttribute('initializing');
    }, 1100)
  }

  const rollstart = (e) => {
    nyaaoowo.removeEventListener('loadeddata', rollstart);
    window.dispatchEvent(new Event('resize'));

    setTimeout(() => {
      if (started) startfr();
      loaded = true;
    }, 1000);
  }

  setTimeout(() => {
    meowmeow = document.getElementById("notice");
    nyaaoowo = document.getElementById("ricky");
    nyanya = document.getElementById("App");

    nyaaoowo.addEventListener('loadeddata', rollstart);
  }, 0);

  const start = (e) => {
    console.log('trying my best to start here... ' + started);
    if (!started) {
      started = true;
      if (nyanya.getAttribute('initializing') == 'processing') {
        nomore();
      }
    }
  }

  const nomore = () => {
    document.removeEventListener('keydown', start);
    document.removeEventListener('mousedown', regPress);
    document.removeEventListener('mouseup', decPress);

    document.getElementById("Rick Astley - Never Gonna Give You Up").style.zIndex = 0;

    const nyaaoowo2 = document.getElementById("notes.txt");
    nyaaoowo2.style.zIndex = 1;
    // nyaaoowo2.parentElement.appendChild(nyaaoowo2);

    if (loaded) startfr();
    else {
      meowmeow.style.fontSize = '4vmin';
      meowmeow.innerHTML = 'loading assets...';
    }
  }

  let holding = 0;
  let pressCheck;
  const regPress = (e) => {
    holding++;
    if (!pressCheck) {
      pressCheck = setTimeout(() => {
        if (holding > 0 && !started) {
          started = true;
          nomore();
        }
        pressCheck = null;
      }, 500)
    }
  }

  const decPress = () => {
    holding--;
  };

  // using deprecated event, because keys like 'alt' will break for some reason
  document.addEventListener('keypress', start);
  document.addEventListener('mousedown', regPress);
  document.addEventListener('mouseup', decPress);

  return (
    <>
      <button id="notice" onClick={start}>
        interact to show page <br/>
  <sub>this page plays sound, which requires your interaction before playing <br/>
       you may long-press the page to skip the intro
  </sub>
      </button>
      <div id="App" initializing='processing'>
        <div>
          <CWindow open='true' offset={{x: 30, y:27}}>{{
            id: "notes.txt",
            icon: "📒",
            contents: <span><Notes rick='true'/></span>
        }}</CWindow>
        <CWindow open='true' offset={{x: 0, y:-2}}>{{
          // id: <a href='https://www.youtube.com/watch?v=dQw4w9WgXcQ'>Rick Astley - Never Gonna Give You Up</a>,
          id: "Rick Astley - Never Gonna Give You Up",
          icon: "🎙️",
          contents: <div><div id='gottem'>
            <video id='ricky' src={gottem} style={{width:"100vmin"}} controls>
              Your browser does not support the video tag.
            </video>
          </div></div>
      }}</CWindow>
        </div>
        <div id='Taskbar'>
          <div id='TaskbarContents'/>
          <div id='TaskbarWidgets'> </div>
        </div>
      </div>
    </>
  );
}

export default Secret;
